<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_acc_gym_checkin.title')">
    <template #content>
      <v-container fluid class="check-in-content">
        <v-row class="flex-grow-0">
          <v-col>
            <v-btn outlined
                   x-large
                   block
                   @click="scanForAccountId">
              <v-icon left>fas fa-qrcode</v-icon>
              {{ $t('admin_acc_gym_checkin.scan_qr_code') }}
            </v-btn>
          </v-col>
        </v-row>
        <div class="subscription-content"
             v-if="subscription">
          <div class="subscription-content-col">
            <v-input hide-details="auto">
              <v-container fluid class="flex-column">
                <legend class="v-label theme--light">{{ $t('admin_acc_gym_checkin.account_pic') }}</legend>
                <v-img thumbnail :src="getURL(hkiaraceAccount.sasv.octopus_back)" contain height="400px"></v-img>
                <v-img thumbnail :src="getURL(hkiaraceAccount.sasv.octopus_front)" contain height="400px"></v-img>
              </v-container>
            </v-input>
            <v-text-field readonly
                          :label="$t('gym_subscription.reference_number')"
                          :value="subscription.reference_number.toString().padStart(10, '0')"></v-text-field>
            <v-text-field readonly
                          :label="$t('admin_user.serial_no')"
                          :value="subscription.account.id"></v-text-field>
            <v-text-field readonly
                          :label="$t('gym_subscription.account')"
                          :value="$t('name', {given_name: subscription.account.given_name, surname: subscription.account.surname})"></v-text-field>
            <v-text-field readonly
                          :label="$t('gym_subscription.status')"
                          :value="$t(BOOKING_STATUS_LABEL[subscription.status])"></v-text-field>
            <v-text-field readonly
                          :label="$t('gym_subscription.type')"
                          :value="subscription.type.name"></v-text-field>
            <v-text-field readonly
                          :label="$t('admin_acc_gym_checkin.has_booking')"
                          :value="$t(`admin_acc_gym_checkin.${booking?'booking':'walkin'}`)"></v-text-field>
            <v-text-field v-if="booking"
                          readonly
                          :label="$t('admin_acc_gym_checkin.booking_time')"
                          :value="$parseDate(booking.create_at)"></v-text-field>
          </div>
          <div class="subscription-content-col">
            <GymSubscriptionCheckInRecordList full-height
                                              :subscription-id="subscription.id"
                                              is-admin
                                              v-if="showCheckInRecords"></GymSubscriptionCheckInRecordList>
          </div>
        </div>
      </v-container>
    </template>
    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               @click="checkIn"
               class="mr-3"
               depressed
               large
               :disabled="!canCheckIn">
          {{ $t('gym_subscription.checkin_time') }}
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>

<script>
import BGModal from "@/components/BGModal";
import {computed, ref, watch} from "@vue/composition-api";
import JwtScanner from "@/components/acc_booking/JwtScanner";
import {BOOKING_STATUS_LABEL} from "@/constants";
import GymSubscriptionCheckInRecordList from "@/components/acc_booking/GymSubscriptionCheckInRecordList";
import PhotoPreviewInput from "@/components/PhotoPreviewInput";

export default {
  name: 'GymCheckInModal',
  components: {PhotoPreviewInput, GymSubscriptionCheckInRecordList, BGModal},
  props: {
    shown: Boolean,
  },

  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);

    // Init
    watch(() => props.shown, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          subscription.value = null;
          booking.value = null;
        }
      }
    });
    const cancel = function () {
      emit('cancel');
    };

    const accountId = ref(null);
    const hkiaraceId = ref(null);
    const scanForAccountId = async function () {
      subscription.value = null;
      booking.value = null;
      let {sub, hkiarace_id} = await root.$dialog.showAndWait(JwtScanner, {
        title: root.$t('admin_acc_gym_checkin.scan_qr_code'),
        targetKey: ['sub', 'hkiarace_id'],
        manualInputKey: ['hkiarace_id'],
        manualInputLabel: root.$t('admin_user.serial_no'),
      });

      accountId.value = sub
      hkiaraceId.value = hkiarace_id

      if (accountId.value || hkiarace_id) {
        getSubscription();
      }
    }

    const subscription = ref(null);
    const hkiaraceAccount = ref(null);
    const booking = ref(null);
    const walkinCapacity = ref(0);
    const getSubscription = function () {
      root.$callAPI('aafb/admin/gym_subscription/', {
        account_id: accountId.value,
        hkiarace_id: hkiaraceId.value,
      }, (response) => {
        subscription.value = response.body.subscription;
        hkiaraceAccount.value = response.body.hkiarace_account;
        booking.value = response.body.bookings[0];
        walkinCapacity.value = response.body.max_capacity - response.body.total_booking - response.body.total_walkin;
      })
    }

    const showCheckInRecords = ref(true);
    const canCheckIn = computed(() => {
      return subscription.value;
      // if (!subscription.value) return false;
      //
      //
      // if (booking.value) {
      //   return !booking.value.checkin_time;
      // } else {
      //   // return walkinCapacity.value > 0;
      //   return true
      // }
    })
    const checkIn = async function () {
      let cardId = await root.$dialog.showAndWait(JwtScanner, {
        title: root.$t('admin_acc_gym_checkin.scan_white_card'),
        targetKey: 'wht',
        manualInputKey: 'wht',
        manualInputLabel: root.$t('admin_acc_white_card.id'),
      });

      if (cardId === undefined) return;

      //
      let regex = /^A([0-9]*)$/;
      if (regex.test(cardId)) {
        cardId = parseInt(cardId.match(regex)[1])
      }

      root.$callAPI('aafb/admin/gym_subscription/checkin/', {
        subscription_id: subscription.value.id,
        booking_id: (booking.value && !booking.value.checkin_time) ? booking.value.id : null,
        white_card_id: cardId,
      }, function (response) {
        getSubscription();
        showCheckInRecords.value = false;
        setTimeout(() => {
          showCheckInRecords.value = true;
        }, 50);

        root.$showAlertMessage(root.$t('admin_acc_gym_checkin.success_msg', {card_id: response.body.white_card_id.toString().padStart(5, '0')}));
      });
    };

    const getURL = function (f) {
      if (f instanceof File) {
        return URL.createObjectURL(f);
      } else {
        return 'api/static/' + f;
      }
    };

    return {
      dialogShown,
      cancel,

      scanForAccountId,

      subscription,
      hkiaraceAccount,
      booking,
      walkinCapacity,

      showCheckInRecords,
      canCheckIn,
      checkIn,

      getURL,

      BOOKING_STATUS_LABEL,
    }
  }
}
</script>

<style lang="less">
.check-in-content {
  display: flex;
  flex-direction: column;
  height: 100%;

  .subscription-content {
    flex: 1 1 0;
    display: flex;
    overflow: hidden;

    .subscription-content-col {
      flex: 1 1 0;
      height: 100%;
      overflow: auto;
    }
  }
}
</style>
